import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Icona } from '../../components/Icona';

/*  LA DESCRIZIONE INTERA, IN UNA FINESTRA. Chiesto da Galizzi il 16/10/2026.

    Le voci da capitolato sono paragrafi interi — «fornitura e posa di defangatore
    magnetico da 1"1/2 femmina con…» — e nella cella della riga se ne legge un pezzo
    alla volta, andando avanti e indietro con la freccia. Ingrandire la riga e' stato
    escluso («diventa sempre piu' grossa»): si fa come in Opera, doppio clic sulla
    descrizione e si apre una finestra dove si legge e si scrive tutto.

    «Applica» salva subito, senza passare dal «Salva la riga»: chi ha riscritto un
    paragrafo in una finestra e l'ha chiusa con un bottone pensa di aver finito, e una
    riga che resta «da salvare» dietro la finestra e' un lavoro perso al primo cambio
    di preventivo. Senza permesso di scrivere la finestra si legge e basta.  */
export function TestoEsteso({
  titolo,
  testo,
  modificabile,
  onApplica,
  onChiudi,
}: {
  titolo: string;
  testo: string;
  modificabile: boolean;
  onApplica: (testo: string) => void;
  onChiudi: () => void;
}) {
  const [bozza, setBozza] = useState(testo);
  const area = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    area.current?.focus();
  }, []);

  useEffect(() => {
    function tasto(e: KeyboardEvent) {
      if (e.key === 'Escape') onChiudi();
    }
    document.addEventListener('keydown', tasto);
    return () => document.removeEventListener('keydown', tasto);
  }, [onChiudi]);

  const vuota = bozza.trim() === '';

  return createPortal(
    <div className="velo-testo-esteso" onMouseDown={(e) => e.target === e.currentTarget && onChiudi()}>
      <div className="testo-esteso" role="dialog" aria-modal="true" aria-label={titolo}>
        <header>
          <strong>{titolo}</strong>
          <button type="button" className="chiudi" aria-label="Chiudi" onClick={onChiudi}>
            <Icona nome="chiudi" />
          </button>
        </header>
        <textarea
          ref={area}
          aria-label="Descrizione completa"
          value={bozza}
          readOnly={!modificabile}
          onChange={(e) => setBozza(e.target.value)}
        />
        <footer>
          {modificabile && vuota && <span className="nota">La descrizione non può restare vuota.</span>}
          <button type="button" onClick={onChiudi}>
            {modificabile ? 'Annulla' : 'Chiudi'}
          </button>
          {modificabile && (
            <button
              type="button"
              className="primario"
              disabled={vuota || bozza === testo}
              onClick={() => onApplica(bozza.trim())}
            >
              Applica
            </button>
          )}
        </footer>
      </div>
    </div>,
    document.body,
  );
}
